import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useRef, useState } from "react";
import { scStringType } from "../../types";
import Slider from "react-slick";
import OnboardingFeatureMedia from "./OnboardingFeatureMedia";
import OnboardingFeatureInfo from "./OnboardingFeatureInfo";

var OnboardingFeatureCarousel = function OnboardingFeatureCarousel(props) {
  var BackButton = props.BackButton,
      NextButton = props.NextButton,
      DoneButton = props.DoneButton,
      Carousel = props.Carousel,
      handleDone = props.handleDone;

  var _useState = useState({
    nav1: null,
    nav2: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useState3 = useState(1),
      _useState4 = _slicedToArray(_useState3, 2),
      currentSlide = _useState4[0],
      setCurrentSlide = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showBack = _useState6[0],
      setShowBack = _useState6[1];

  var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      showNext = _useState8[0],
      setShowNext = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      showDone = _useState10[0],
      setShowDone = _useState10[1];

  var slider1 = useRef();
  var slider2 = useRef();
  var featuresCount = (Carousel === null || Carousel === void 0 ? void 0 : Carousel.length) || 1;
  useEffect(function () {
    setState({
      nav1: slider1.current,
      nav2: slider2.current
    });
  }, []);
  useEffect(function () {
    setShowBack(currentSlide > 1 && currentSlide <= featuresCount);
    setShowNext(currentSlide < featuresCount);
    setShowDone(currentSlide >= featuresCount);
  }, [currentSlide]);
  var nav1 = state.nav1,
      nav2 = state.nav2;

  var handleBack = function handleBack() {
    slider1.current.slickPrev();
  };

  var handleNext = function handleNext() {
    slider1.current.slickNext();
  };

  var carouselSettings = {
    dots: true,
    infinite: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    swipeToSlide: false,
    draggable: false,
    adaptiveHeight: true,
    accessibility: false,
    swipe: false,
    touchMove: false,
    centerMode: false,
    lazyLoad: "ondemand"
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "onboarding-feature-carousel"
  }, /*#__PURE__*/React.createElement("div", {
    className: "onboarding-features"
  }, /*#__PURE__*/React.createElement(Slider, _extends({}, carouselSettings, {
    className: "onboarding-feature--media__wrapper",
    asNavFor: nav2,
    ref: function ref(slider) {
      return slider1.current = slider;
    },
    beforeChange: function beforeChange(oldIndex, newIndex) {
      setCurrentSlide(newIndex + 1);
    }
  }), Carousel && Carousel.map(function (feature, index) {
    var _feature$fields;

    var indexPlus = index + 1;
    return /*#__PURE__*/React.createElement(OnboardingFeatureMedia, {
      Features: (_feature$fields = feature.fields) === null || _feature$fields === void 0 ? void 0 : _feature$fields.Features,
      key: "onboarding-feature-media-".concat(index),
      play: currentSlide === indexPlus
    });
  })), /*#__PURE__*/React.createElement(Slider, _extends({}, carouselSettings, {
    className: "onboarding-feature--info__wrapper",
    dots: false,
    asNavFor: nav1,
    ref: function ref(slider) {
      return slider2.current = slider;
    }
  }), Carousel && Carousel.map(function (feature, index) {
    var _feature$fields2, _feature$fields3;

    return /*#__PURE__*/React.createElement(OnboardingFeatureInfo, {
      Header: (_feature$fields2 = feature.fields) === null || _feature$fields2 === void 0 ? void 0 : _feature$fields2.Header,
      Description: (_feature$fields3 = feature.fields) === null || _feature$fields3 === void 0 ? void 0 : _feature$fields3.Description,
      key: "onboarding-feature-info-".concat(index)
    });
  }))), /*#__PURE__*/React.createElement("div", {
    className: "onboarding-feature-carousel__navigation"
  }, showBack ? /*#__PURE__*/React.createElement("button", {
    className: "cb-button-secondary w-100",
    onClick: handleBack
  }, BackButton === null || BackButton === void 0 ? void 0 : BackButton.value) : null, showNext ? /*#__PURE__*/React.createElement("button", {
    className: "cb-button-primary w-100",
    onClick: handleNext
  }, NextButton === null || NextButton === void 0 ? void 0 : NextButton.value) : null, showDone ? /*#__PURE__*/React.createElement("button", {
    className: "cb-button-primary w-100",
    onClick: handleDone
  }, DoneButton === null || DoneButton === void 0 ? void 0 : DoneButton.value) : null));
};

export default OnboardingFeatureCarousel;